$(function() {

	var $el = {
		triggers: $('.jq-header-submenu, .jq-header-dropdown'),
		state: $('.jq-submenu-status'),
		links: $('.jq-header-submenu-link'),
		thumbs: $('.jq-header-submenu-thumb'),
	};

	var temp = {};

	$el.triggers
		.on('touchstart', function(event) {

			temp[event.currentTarget] = {
				startX: event.originalEvent.changedTouches[0].screenX,
				startY: event.originalEvent.changedTouches[0].screenY,
			};

		})
		.on('touchend', function(event) {

			var diffX = event.originalEvent.changedTouches[0].screenX - temp[event.currentTarget]['startX'];

			var diffY = event.originalEvent.changedTouches[0].screenY - temp[event.currentTarget]['startY'];

			var ratioX = Math.abs(diffX / diffY);

			var ratioY = Math.abs(diffY / diffX);

			var absDiff = Math.abs(ratioX > ratioY ? diffX : diffY);

			// Ignore small movements.
			if (absDiff < 30) {
				return;
			}

			if (ratioX > ratioY) {
				$el.state.prop('checked', (diffX >= 0 ? true : false)).trigger('change');
			}

		});

	$el.links.on('mouseenter mouseleave', function(event) {
		var $submenuThumbs = $(this).parents('.jq-header-dropdown').find('.jq-header-submenu-thumb');

		var $submenuDefaultThumb = $submenuThumbs.find('.jq-header-submenu-thumb-image');

		if (event.type == 'mouseenter') {
			$el.links.not(this).addClass('is-disabled');

			var $linkThumb = $($(this).data('thumb'));

			if ($linkThumb.length) {
				if (typeof delayShowDefaultThumb !== 'undefined') clearTimeout(delayShowDefaultThumb);

				if ($linkThumb.hasClass('d-none')) {
					loadLazyImages($linkThumb[0]);

					$submenuThumbs.append($linkThumb);

					$linkThumb
						.hide()
						.removeClass('d-none');
				}

				$linkThumb.fadeIn();

				$submenuDefaultThumb.fadeOut();
			}
		} else {
			$el.links.not(this).removeClass('is-disabled');

			var $linkThumb = $($(this).data('thumb'));

			if ($linkThumb.length) {
				$linkThumb.fadeOut();

				delayShowDefaultThumb = setTimeout(function(){
					$submenuDefaultThumb.fadeIn();
				}, 200);
			}
		}
	});

	$el.triggers.on('mouseenter.lazyImages', function() {

		var $activeTrigger = $(this);

		var $lazyImages = $('.jq-header-submenu-thumb img[data-src]', $activeTrigger);

		if ($lazyImages.length) {

			$lazyImages.each(loadLazyImages);

		}

		$activeTrigger.off('mouseenter.lazyImages');

	});

	function loadLazyImages(image) {
		if (!image || typeof image == 'undefined') {
			image = this;
		}

		image.src = image.dataset.src;

		image.removeAttribute('data-src');

		if (image.dataset.srcset) {

			image.srcset = image.dataset.srcset;

			image.removeAttribute('data-srcset');

		}
	}

});
